export default [
  {
    path: "after-sale/market-punch",
    name: "MarketPunch",
    component: () => import("@/pages/AfterSale/MarketPunch.vue"),
    meta: {
      title: "市场打卡记录",
      requireAuth: true,
    },
  },
  {
    path: "after-sale/refund-outbound-verify",
    name: "RefundOutboundVerify",
    component: () => import("@/pages/AfterSale/RefundOutboundVerify.vue"),
    meta: {
      title: "退换货出库校验",
      requireAuth: true,
    },
  },
  {
    path: "after-sale/refund-outbound-verify-log",
    name: "RefundOutboundVerify",
    component: () =>
      import("@/pages/AfterSale/RefundOutboundVerifyLog/index.vue"),
    meta: {
      title: "退换货校验日志",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/afterSale.js